import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Span from '@deliveroo/consumer-component-library/components/Span';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';
import i18n from '../../utils/i18n';

import styles from './ChangeRow.scss';

const ChangeRow = ({ icon, contentLines, isDisabled, onClick }) => (
  <UnstyledButton isBlock isDisabled={isDisabled} onClick={onClick}>
    <div className={styles.wrapper}>
      <Icon component={icon} color="light-grey" spacing="0 medium 0 0" />

      <div className={styles.flexContent}>
        {contentLines.map((contentLine) => (
          <Span isBlock key={contentLine}>
            {contentLine}
          </Span>
        ))}
      </div>

      {!isDisabled && (
        <Span color="teal" spacing="0 0 0 medium">
          {i18n.gettext('Change')}
        </Span>
      )}
    </div>
  </UnstyledButton>
);

ChangeRow.propTypes = {
  icon: PropTypes.elementType.isRequired, // eslint-disable-line react/no-typos
  contentLines: PropTypes.arrayOf(PropTypes.string).isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ChangeRow.defaultProps = {
  isDisabled: false,
};

export default ChangeRow;
